module.exports = __webpack_public_path__ + "img/20250521_manavisfesta_01.bb0ec285.jpg";